import React from 'react'
import './DefaultRoute.css'

const DefaultRoute = () => {
    return (
        <div className="img-conatainer">
            <img src='images/comingsoon.png' alt='coming soon' />
        </div>
    )
}

export default DefaultRoute
